export type UserConsentActions = MatomoUserConsentChanged | VideoUserConsentChanged | MatomoStarting | MatomoStarted;

export function videoUserConsentChanged(consent: boolean) {
  return {
    type: 'VIDEO_USER_CONSENT_CHANGED' as const,
    consent,
  };
}

export type VideoUserConsentChanged = ReturnType<typeof videoUserConsentChanged>;

export function matomoUserConsentChanged(consent: boolean) {
  return {
    type: 'MATOMO_USER_CONSENT_CHANGED' as const,
    consent,
  };
}

export type MatomoUserConsentChanged = ReturnType<typeof matomoUserConsentChanged>;

export function matomoStarting(
  matomoBaseUrl: string,
  matomoSiteId: number,
  login: string,
  isUserInternal: boolean,
  companyName: string,
) {
  return {
    type: 'MATOMO_STARTING' as const,
    matomoBaseUrl,
    matomoSiteId,
    login,
    isUserInternal,
    companyName,
  };
}

export type MatomoStarting = ReturnType<typeof matomoStarting>;
export function matomoStarted() {
  return {
    type: 'MATOMO_STARTED' as const,
  };
}

export type MatomoStarted = ReturnType<typeof matomoStarted>;
